import React from 'react';
import { Box, Progress, Flex, Text } from '@mantine/core';
import { IProgresBar } from './ticket-validation.interface';
import { Users } from 'lucide-react';

interface SeatsProgressBarProps {
    seats: IProgresBar;
    t: (key: string) => string;
}

const SeatsProgressBar: React.FC<SeatsProgressBarProps> = ({ seats, t }) => {
    return (
        <Box style={{ position: 'relative' }}>
            <Progress
                value={seats.percentage}
                striped
                h={22}
                radius={0}
            />
            <Flex
                w={'100%'}
                justify={"space-between"}
                align={"baseline"}
                px={5}
                style={{ position: 'absolute', top: 0 }}
            >
                <Text c="white" size="sm" ta="center" fw="bold">
                    <Flex align={"center"}>
                        <Users />
                        <Box ml={5}>{seats.used}</Box>
                    </Flex>
                </Text>
                <Text c="red" size="sm" ta="center" fw="bold">
                    <Flex align={"center"}>
                        <Users />
                        <Box ml={5}>{seats.total}</Box>
                    </Flex>
                </Text>
            </Flex>
        </Box>
    );
};

export default SeatsProgressBar;
